import React from "react";
import VideoThumbnail from "./VideoThumbnail";
import VideoDetails from "./VideoDetails";
import { MOBILE_THUMBNAIL_WIDTH, MOBILE_GAP } from "../utils/constants";

export default function MobileVideoCarousel({
  videos,
  activeIndex,
  setActiveIndex,
  isLoading,
  mobileCarouselRef,
  thumbnailRefs,
  handleMobileScroll,
  handleTouchStart,
  handleTouchMove,
  handleTouchEnd,
}) {
  const activeVideo = videos[activeIndex];

  return (
    <div className="w-full">
      {/* Mobile Video Carousel */}
      <div className="flex flex-col gap-4 w-full">
        {/* Mobile Thumbnails Row */}
        <div className="relative overflow-hidden -mx-6 xl:-mx-16">
          <div
            className="overflow-x-auto scrollbar-hide px-6 xl:px-16"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
            ref={mobileCarouselRef}
            onScroll={handleMobileScroll}
          >
            <div
              className="flex gap-4 items-start pb-4 pt-4"
              style={{
                width: `${videos.length * (MOBILE_THUMBNAIL_WIDTH + MOBILE_GAP)}px`,
              }}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
              role="tablist"
              aria-label="Video thumbnails"
            >
              {videos.map((video, index) => (
                <VideoThumbnail
                  key={index}
                  video={video}
                  index={index}
                  isActive={index === activeIndex}
                  isLoading={isLoading}
                  onClick={setActiveIndex}
                  width={MOBILE_THUMBNAIL_WIDTH}
                  height={182.4}
                  isMobile={true}
                  thumbnailRef={(el) => (thumbnailRefs.current[index] = el)}
                />
              ))}
            </div>
          </div>

          {/* Edge fade indicators for mobile */}
          <div className="absolute left-0 top-0 bottom-0 w-6 xl:w-16 bg-gradient-to-r from-[#0f0624] to-transparent pointer-events-none z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-6 xl:w-16 bg-gradient-to-l from-[#0f0624] to-transparent pointer-events-none z-10" />
        </div>

        {/* Mobile Dot Indicators */}
        {videos.length > 1 && (
          <div className="flex justify-center gap-2">
            {videos.map((_, index) => (
              <button
                key={index}
                className={`w-2 h-2 rounded-full transition-all duration-300 focus:outline-none focus:ring-1 focus:ring-[#c5bbff] ${
                  index === activeIndex
                    ? "bg-[#c5bbff] w-6"
                    : "bg-white/30 hover:bg-white/50"
                }`}
                onClick={() => setActiveIndex(index)}
                aria-label={`Go to video ${index + 1}`}
              />
            ))}
          </div>
        )}

        {/* Mobile Bottom Details Section */}
        <div className="flex flex-col gap-3 py-3 w-full">
          <VideoDetails video={activeVideo} isMobile={true} />
        </div>
      </div>
    </div>
  );
}
